import { render } from "./BuildingView.vue?vue&type=template&id=7fc70310&scoped=true"
import script from "./BuildingView.vue?vue&type=script&lang=js"
export * from "./BuildingView.vue?vue&type=script&lang=js"

import "./BuildingView.vue?vue&type=style&index=0&id=7fc70310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc70310"]])

export default __exports__